import * as Yup from "yup";
import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  selectValidation,
  stringValidation,
  fileValidation,
  arrayValidation,
} from "../providers/validations";
import Field from "../components/Field";
import { FileUpload, Select, Text } from "../inputs";
import { Form } from "../template";
import { SHA256 } from "crypto-js";
import { mainApi } from "../providers/api";
import objectPath from "object-path";
import { classificationType } from "../type/Form";

const UserForm = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const props = {
    editable: true,
    isDeletable: true,
    model: "sign",
    text: id ? "Тэмдэгийн мэдээлэл" : "Тэмдэг бүртгэх",
    id: id,
    init: {},
    validationSchema: Yup.object().shape({
      image: fileValidation(true),
      name: stringValidation(true),
      classification: selectValidation(true),
      type: selectValidation(true),
      sizeList: arrayValidation(true),
      materialList: arrayValidation(true),
    }),
  };
  const beforeSubmit = async (data) => {
    console.log("🚀 ~ beforeSubmit ~ data:", data);
    return data;
  };

  return (
    <Form {...props} beforeSubmit={beforeSubmit}>
      {({ submited, disabled, values }) => {
        const classification = objectPath.get(values, "classification");
        console.log("🚀 ~ UserForm ~ classification:", values);
        return (
          <div className="p-5 bg-white  grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="flex flex-col gap-4">
              <Field
                name="image"
                label={t("sign.image")}
                disabled={disabled}
                component={FileUpload}
                type="text"
                className={`text-black `}
              />
            </div>
            <div className="flex flex-col gap-4 min-h-screen">
              <Field
                name="classification"
                label={t("sign.classification")}
                disabled={disabled}
                component={Select}
                items={classificationType}
              />
              {classification && (
                <Field
                  name="type"
                  label={t("sign.type")}
                  disabled={disabled}
                  component={Select}
                  axio={`/type/select/${classification}`}
                  axioAdapter={(data) => {
                    return data.map(({ _id, type }) => ({
                      value: _id,
                      label: type,
                    }));
                  }}
                />
              )}
              <Field
                name="name"
                label={t("sign.name")}
                disabled={disabled}
                component={Text}
                type="text"
              />
              <Field
                name="seo"
                label={`SEO`}
                disabled={disabled}
                component={Text}
                type="text"
              />
              <Field
                name="sequence"
                label={t("sign.sequence")}
                disabled={disabled}
                component={Text}
                type="text"
              />
              <Field
                name="materialList"
                label={t("sign.material")}
                disabled={disabled}
                component={Select}
                axio={`/consts/select/material`}
                type="select"
                axioAdapter={(data) => {
                  return data.map(({ _id, name }) => ({
                    value: _id,
                    label: name,
                  }));
                }}
                isMulti={true}
              />
              <Field
                name="sizeList"
                label={t("sign.size")}
                disabled={disabled}
                component={Select}
                axio={`/consts/select/size`}
                type="select"
                axioAdapter={(data) => {
                  return data.map(({ _id, name }) => ({
                    value: _id,
                    label: name,
                  }));
                }}
                isMulti={true}
              />
            </div>
          </div>
        );
      }}
    </Form>
  );
};

export default UserForm;
